import expiredIndicator from './expiredIndicator';
import menu from './menu';
import permissionChecks from './permissionChecks';

export default {
  expiredIndicator,
  menu,
  permissionChecks,
};
